/**
 * Created by Daniel on 3/04/2017.
 */

import React, { Component } from 'react';
import ScenarioManagement from '../presentation/ScenarioManagement';

class ScenarioManagementWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            scenarios: [],
            selectedScenario: '',
            errorField: '',
            search: '',
            sort: 'lastUpdateTime',
            sortAsc: false,
            showEditScenarioForm: false,
            formData: {
                name: '',
                apiKey: '',
                customerApiKey: '',
                email: '',
                state: 'Active',
                numberZones: '',
                comments: '',
                environment: '',
                scenarioId: '',
            },
            formErrors: {},
        };

        this.emptyState = {
            name: '',
            apiKey: '',
            customerApiKey: '',
            email: '',
            state: 'Active',
            numberZones: '',
            comments: '',
            environment: '',
            scenarioId: '',
        };
    }

    componentDidMount() {
        this.getScenarioList();
    }

    loadList = data => {
        this.setState({ scenarios: data, isLoading: false });
    };

    getScenarioList = callback => {
        this.setState({ isLoading: true }, () => {
            fetch(
                '/service/scenarios?search=' +
                    this.state.search +
                    '&sort=' +
                    this.state.sort +
                    '&sortAsc=' +
                    this.state.sortAsc,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'same-origin',
                },
            ).then(response => {
                if (response.status !== 200) {
                    response.json().then(() => {
                        this.setState({ isLoading: false });
                    });
                } else {
                    response.json().then(scenarios => {
                        const selectedScenario = scenarios.length ? scenarios[0] : '';
                        this.setState({ scenarios, selectedScenario, isLoading: false }, callback);
                        this.loadList(scenarios);
                    });
                }
            });
        });
    };

    selectScenario = id => {
        const { scenarios } = this.state;
        const [selectedScenario] = scenarios.filter(scenario => scenario._id === id);
        this.setState({ selectedScenario: selectedScenario || '' });
    };

    updateSortState = sortBy => {
        this.setState(prevState => {
            return sortBy === prevState.sort ? { sortAsc: !prevState.sortAsc } : { sort: sortBy };
        }, this.getScenarioList);
    };

    updateSearchState = e => {
        this.setState({ search: e.target.value }, () => {
            this.getScenarioList();
        });
    };

    deleteScenario = scenarioId => {
        if (confirm('Are you sure you want to delete this scenario?')) {
            fetch('/service/deleteScenario', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ scenarioId: scenarioId }),
            }).then(response => {
                if (response.status !== 200) {
                    response.json().then(json => {
                        this.setState({
                            serverError: 'Error! Scenario could not be deleted',
                        });
                    });
                } else {
                    const newScenarios = {
                        scenarios: this.state.scenarios.filter(scenario => scenario._id !== scenarioId),
                    };
                    this.setState(newScenarios);

                    this.props.navigator.requestScenarioManagement();
                    this.getScenarioList();
                }
            });
        }
    };

    /* Form methods */
    handleEditScenarioComments = comments => {
        const body = {
            ...this.state.selectedScenario,
            comments,
        };

        fetch('/service/editScenario', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status !== 200) {
                    console.log('ERROR SAVING COMMENTS');
                } else {
                    this.getScenarioList();
                    console.log('Scenario comments updated succesfully');
                }
            })
            .catch(console.error);
    };



    showEditScenarioForm = currentScenario => {
        if (currentScenario) {
            let formData = { ...currentScenario };
            formData.scenarioId = currentScenario._id;
            delete formData._id;
            this.setState({
                showEditScenarioForm: true,
                formData,
                formDataPreviousState: { ...formData },
            });
            //Prevent user from scrolling page while popup is visible
            document.getElementsByTagName('html')[0].classList.add('no-scroll');
        } else {
            this.setState({
                showEditScenarioForm: true,
                formDataPreviousState: { ...this.emptyState },
            });
        }
    };

    hideEditScenarioForm = overrideConfirm => {
        const emptyErrorState = {
            error: false,
            errorField: '',
            success: '',
            serverError: '',
        };

        const callback = this.getScenarioList;

        if (
            JSON.stringify(this.state.formData) === JSON.stringify(this.state.formDataPreviousState) ||
            overrideConfirm ||
            confirm('Discard changes?')
        ) {
            this.setState(
                {
                    showEditScenarioForm: false,
                    formData: { ...this.emptyState },
                    formErrors: emptyErrorState,
                },
                callback,
            );
            document.getElementsByTagName('html')[0].classList.remove('no-scroll');
        }
    };

    render() {
        return (
            <ScenarioManagement
                navigator={this.props.navigator}
                loadData={this.state}
                selectScenario={this.selectScenario}
                updateSearchState={this.updateSearchState}
                updateSortState={this.updateSortState}
                deleteScenario={this.deleteScenario}
                handleEditScenarioComments={this.handleEditScenarioComments}
                showEditScenarioForm={this.showEditScenarioForm}
                hideEditScenarioForm={this.hideEditScenarioForm}
            />
        ); //return
    } //render
} //ScenarioManagementWidget

export default ScenarioManagementWidget;
